import { render } from "./EmployeeType.vue?vue&type=template&id=6291ca15&scoped=true"
import script from "./EmployeeType.vue?vue&type=script&lang=js"
export * from "./EmployeeType.vue?vue&type=script&lang=js"

import "./EmployeeType.vue?vue&type=style&index=0&id=6291ca15&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6291ca15"]])

export default __exports__